import {getSize} from 'platform/foundation';

/** Height of one row in the all-day header. */
export const CSS_ALL_DAY_EVENT_HEIGHT = getSize(6);
